import React, { useEffect } from 'react';
import {
  makeStyles,
  createStyles,
  Theme,
} from '@material-ui/core';

import {useDispatch, useSelector} from 'react-redux';
import StudioComponent from './StudioComponent';
import { useUploadRecordFiles, UploadRecordContext } from './record/UploadRecordContext';
import RecordPreviewModal from './camera/record/record-preview/RecordPreviewModal';
import {setTextStudio, setupStudio} from '../../store/modules/studio/actions';
import {getAllQueryData, updateQuery} from "../../utility/helpers";
import {setCurrentSceneId} from "../../store/modules/scenes/actions";
import {selectCurrentSceneId, selectListScenes} from "../../store/modules/scenes/selectors";
import {parseScript} from "./utils";
import {selectProject} from "../../store/modules/projects/selectors";

const useStyles = makeStyles(({ palette }: Theme) => createStyles({
  root: {
    background: palette.studio.background,
    position: 'fixed',
    overflowX: 'hidden',
    overflowY: 'auto',
    zIndex: 2147483101,
    right: 0,
    bottom: 0,
    top: 0,
    left: 0,
  },
}), { name: 'Studio' });

const Studio = () => {
  const classes = useStyles();
  const recordContext = useUploadRecordFiles();
  const dispatch = useDispatch();
  const scriptList = useSelector(selectListScenes);
  const currentSceneId = useSelector(selectCurrentSceneId);
  const currentProject = useSelector(selectProject);

  useEffect(() => {
    if(currentProject){
      dispatch(setupStudio());
    }
  }, [currentProject, dispatch]);

  useEffect(() => {
    if (scriptList.data?.items?.length) {
      const query = getAllQueryData();
      // eslint-disable-next-line
      if (query.hasOwnProperty('scriptId')) {
        const queryScriptId = Number(query.scriptId);
        if (!Number.isNaN(queryScriptId)) {
          let scriptId = currentSceneId;

          if (queryScriptId !== currentSceneId) {
            const currentScript = scriptList.data.items.find((item) => item.id === queryScriptId);
            if (currentScript) {
              scriptId = queryScriptId;
            } else {
              scriptId = scriptList.data.items[0].id || 0;
            }
          }
          dispatch(setCurrentSceneId(scriptId));
          updateQuery({ scriptId });
        } else {
          const scriptId = scriptList.data.items[0].id || 0;
          updateQuery({ scriptId });
          dispatch(setCurrentSceneId(scriptId));
        }
      } else {
        const currentScript = scriptList.data.items.find((item) => item.id === currentSceneId);
        if (currentScript) {
          updateQuery({ scriptId: currentSceneId });
        } else {
          const scriptId = scriptList.data.items[0].id;
          updateQuery({ scriptId });
          dispatch(setCurrentSceneId(scriptId));
        }
      }
    }
  }, [dispatch, scriptList, currentSceneId]);

  useEffect(() => {
    const currentScript = scriptList.data?.items.find((item) => item.id === currentSceneId);
    const promptText = parseScript(
      currentScript?.script || '',
      { project: currentProject.data },
    );
    dispatch(setTextStudio(promptText));
  }, [dispatch, scriptList, currentSceneId, currentProject]);

  return (
    <div className={classes.root}>
      <UploadRecordContext.Provider value={recordContext}>
        <RecordPreviewModal />
        <StudioComponent />
      </UploadRecordContext.Provider>
    </div>
  );
};

export default Studio;
